<template>
	<div class="not-found">
		<span
			aria-hidden="true"
			class="not-found__icon">
			<FontAwesomeIcon icon="fal fa-file-magnifying-glass" />
		</span>
		<h1 class="not-found__code">404</h1>
		<p class="not-found__text">Strani ni mogoče najti.</p>
		<Button
			icon="fal fa-home"
			label="Na začetno stran"
			@click="router.replace('/')" />
	</div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import Button from 'primevue/button'
import FontAwesomeIcon from '@/components/FontAwesomeIcon.vue'

const router = useRouter()
</script>

<style lang="scss" scoped>
.not-found {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	min-height: 100vh;
	width: 100%;
	padding: 32px 16px;
	text-align: center;

	.not-found__icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 64px;
		height: 64px;
		margin-bottom: 8px;
		border-radius: 18px;
		background: var(--p-primary-50);
		color: var(--p-primary-700);
		font-size: 28px;

		@media (prefers-color-scheme: dark) {
			background: color-mix(in srgb, var(--p-primary-400) 16%, transparent);
			color: var(--p-primary-200);
		}
	}

	.not-found__code {
		margin: 0;
		font-size: 56px;
		font-weight: 700;
		letter-spacing: -0.04em;
		line-height: 1;
		color: var(--p-text-color);
	}

	.not-found__text {
		margin: 0 0 12px;
		font-size: 16px;
		color: var(--p-text-muted-color);
	}
}
</style>
